import { Button } from "@material-ui/core";
import { Theme, Grid, makeStyles } from "@material-ui/core";
import React, { useEffect } from "react";
import QueryString from "query-string";
import { useHistory } from "react-router-dom";
import { getApiUrl } from "utils/network";
import { useDispatch, useSelector } from "react-redux";
import { loginAction } from "redux/reducers/userReducer";
import { RootState } from "redux/reducers/rootReducer";

const useStyles = makeStyles(({ palette, spacing }: Theme) => ({
    background: {
        width: "100vw",
        height: "100vh",
        backgroundColor: palette.primary.main,
        position: "absolute",
        zIndex: -999,
    },
    prestoLogo: {
        marginBottom: spacing(4),
        "@media (max-height: 600px)": {
            marginBottom: 0,
        },
    },
    gridContainer: {
        height: "100vh",
        backgroundColor: palette.primary.main,
        minHeight: "480px",
        paddingBottom: "100px",
        "@media (max-height: 600px)": {
            paddingBottom: 0,
        },
    },
    mainContainer: {
        flex: 1,
    },
    loginForm: {
        margin: spacing(2),
        "& .MuiTextField-root": {
            marginBottom: spacing(2),
        },
    },
    loginFormInputs: {
        color: "#fff",
        borderBottom: "2px solid white",
        backgroundColor: "#18394e !important",
    },
    loginFormLabel: {
        color: "#fff",
        "&.Mui-focused": {
            color: "#fff",
        },
        "& .MuiInputLabel-asterisk": {
            display: "none",
        },
    },
    contactContainer: {
        marginTop: spacing(2),
    },
    contact: {
        display: "flex",
        alignItems: "center",
        padding: spacing(1, 0),
        "& a": {
            textDecoration: "none",
            color: palette.primary.dark,
        },
    },
}));

export const Login = () => {
    const classes = useStyles();
    const history = useHistory();
    const queryParams = QueryString.parse(history.location.search);
    const code = queryParams["code"] as string;
    const scope = queryParams["scope"] as string;
    const dispatch = useDispatch();
    const loginLoading = useSelector(
        (state: RootState) => state.user.loginLoading
    );

    useEffect(() => {
        if (code && scope) {
            dispatch(
                loginAction({
                    code,
                    scope,
                })
            );
        }
    }, [code, scope, dispatch]);

    return (
        <React.Fragment>
            <div className={classes.background} />
            <Grid
                className={classes.gridContainer}
                container
                direction="column"
                alignItems="center"
            >
                <Grid
                    container
                    className={classes.mainContainer}
                    direction="column"
                    alignItems="center"
                    justify="space-around"
                >
                    <Grid item>
                        <img
                            className={classes.prestoLogo}
                            src={
                                process.env.PUBLIC_URL +
                                "/images/presto_logo_white.png"
                            }
                            alt="Presto Logo"
                        />
                    </Grid>
                    <Grid item>
                        <Button
                            variant="contained"
                            color="secondary"
                            size="large"
                            href={getApiUrl() + "/auth/google"}
                            disabled={loginLoading}
                        >
                            {!loginLoading
                                ? "Login with Google"
                                : "Logging in with Google..."}
                        </Button>
                    </Grid>
                    <Grid item />
                </Grid>
            </Grid>
        </React.Fragment>
    );
};
